import MainLayout from "./main";
import PopupLayout from "./popup";

const LayoutProvider = ({ children }: any) => {
    const url = new URL(window.location.href);
    const isPopup = url.searchParams.get("ppup") === "Y";
    return isPopup ? <PopupLayout>{children}</PopupLayout> : <MainLayout>{children}</MainLayout>;
};

export default LayoutProvider;
